<script setup lang="ts">
import CloseWindowIconBtn from '@/components/iconBtns/CloseWindowIconBtn.vue';

export interface Props {
  showCloseBtn?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showCloseBtn: true,
});

const emit = defineEmits<{
  closeClick: [event: Event];
}>();

function handleCloseClick(event: Event): void {
  emit('closeClick', event);
}
</script>

<template>
  <header
    :class="$style.reportGenerateDialogHeader"
    data-testid="reportGenerateDialogHeader"
  >
    <div>
      <h1 :class="$style.h1"><slot></slot></h1>
    </div>
    <div v-if="props.showCloseBtn">
      <CloseWindowIconBtn :class="$style.closeBtn" @click="handleCloseClick" />
    </div>
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/variables';

.reportGenerateDialogHeader {
  display: flex;
  justify-content: space-between;
}
  .h1 {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    margin: 0;
  }
  .closeBtn {
    position: absolute;
    margin-top: -5px;
    margin-left: -30px;
  }
</style>
